import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ScreenTrackingService, UserTrackingService} from '@angular/fire/analytics';
import {connectFunctionsEmulator, Functions} from '@angular/fire/functions';
import {RouterOutlet} from '@angular/router';
import {environment} from '../environments/environment';
import {MetadataService} from './common/metadata.service';
import {ModalContainerComponent} from './common/modal/modal-container.component';
import {NoInternetService} from './common/no-internet.service';
import {RouteValidatorService} from './common/route-validator.service';
import {ToastContainerComponent} from './common/toast';
import {UpdateService} from './common/update.service';

@Component({
    selector: 'nexus-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, ToastContainerComponent, ModalContainerComponent]
})
export class AppComponent {
  constructor(
    readonly noInternetService: NoInternetService,
    readonly updateService: UpdateService,
    readonly screenTrackingService: ScreenTrackingService,
    readonly userTrackingService: UserTrackingService,
    readonly routeValidatorService: RouteValidatorService,
    readonly metadataService: MetadataService,
    private readonly functions: Functions,
  ) {

    if(environment.useEmulatedFunctions) {
      connectFunctionsEmulator(this.functions, "127.0.0.1", 5001);
    }
  }
}
